const initBubbleCards = (wait_for_reco) => {
  let productItems;

  if (wait_for_reco) {
    productItems = document.querySelectorAll(
      ".lbc-bubble-card[data-wait-for-reco='true']"
    );
  } else {
    productItems = document.querySelectorAll(
      ".lbc-bubble-card[data-wait-for-reco='false']"
    );
  }
  
  const productItemContainer = document.querySelector(
    ".product__info"
  );
  
  if (productItems && window.innerWidth < 768) {
    productItems.forEach((item) => {
      const productItemLinkCard = item.querySelector(".lbc-bubble-card__hover-card")
      const productItemLink = item.querySelector(
        ".lbc-bubble-card__bubble"
      );
      let isItemCardOpen =
        productItemLink.getAttribute("data-item-card-is-open") === "true";
  
      productItemLink.addEventListener("click", (e) => {
        console.log(productItemLink)
        e.preventDefault();
        if (!isItemCardOpen) {
          isItemCardOpen = true;
          productItemLink.setAttribute("data-item-card-is-open", "true");
        } else {
          window.location.href = productItemLink.getAttribute("href");
        }
      });
  
      document.addEventListener("click", (e) => {
        if (!item.contains(e.target)) {
          isItemCardOpen = false;
          productItemLink.setAttribute("data-item-card-is-open", "false");
        }
      });
  
      const isCardOutOfScreen = () => {
        const productItemLinkCardRect = productItemLinkCard.getBoundingClientRect();
        const productItemContainerRect = productItemContainer.getBoundingClientRect();
  
        if (productItemLinkCardRect.left < productItemContainerRect.left){
          productItemLinkCard.classList.add('lbc-bubble-card__hover-card--left');
        } else if(productItemLinkCardRect.right > productItemContainerRect.right){
          productItemLinkCard.classList.add('lbc-bubble-card__hover-card--right');
        } else {
        }
      }
      
      productItemLink.addEventListener("click", isCardOutOfScreen);
      productItemLink.addEventListener("mouseenter", isCardOutOfScreen);
    });
  }
}

initBubbleCards(false);
window.addEventListener("lbc-reco-loaded", () => initBubbleCards(true));
